const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Request failed.');
  }
  return payload;
}

export async function getMentorList() {
  const res = await fetch(`${apiBase}/api/users/by-role/teacher`);
  return handleResponse(res);
}

export async function getMentorEnrollments(teacherId) {
  if (!teacherId) throw new Error('teacherId is required');
  const res = await fetch(`${apiBase}/api/enrollments/by-mentor/${teacherId}`);
  return handleResponse(res);
}

export async function getUnassignedEnrollments() {
  const res = await fetch(`${apiBase}/api/enrollments/unassigned`);
  return handleResponse(res);
}

export async function assignMentor(enrollmentId, teacherId) {
  if (!enrollmentId || !teacherId) throw new Error('enrollmentId and teacherId are required');
  const res = await fetch(`${apiBase}/api/enrollments/${enrollmentId}/assign`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ teacherId }),
  });
  return handleResponse(res);
}

export async function unassignMentor(enrollmentId) {
  if (!enrollmentId) throw new Error('enrollmentId is required');
  const res = await fetch(`${apiBase}/api/enrollments/${enrollmentId}/unassign`, {
    method: 'PATCH',
  });
  return handleResponse(res);
}

export async function createTeacher({ firstName, lastName, email, tagline, subjects, courseIds }) {
  const res = await fetch(`${apiBase}/api/users/create-teacher`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ firstName, lastName, email, tagline, subjects, courseIds }),
  });
  return handleResponse(res);
}

export async function removeTeacher(teacherId, force = false) {
  const url = `${apiBase}/api/users/teacher/${teacherId}${force ? '?force=true' : ''}`;
  const res = await fetch(url, { method: 'DELETE' });
  return handleResponse(res);
}
